import { toLocalYMD } from '../../../utils/dateUtils';

export function getHuntersInWoods(club) {
  if (!club?.hunt_locations) return [];
  const today = toLocalYMD(new Date());
  const hunters = [];
  club.hunt_locations.forEach((location) => {
    if (location?.sign_out_records) {
      location.sign_out_records.forEach((record) => {
        if (record.date === today) {
          hunters.push({
            locationName: location.name,
            locationId: location.id,
            userName: record.user_name || `User ${record.user_id}`,
            timePeriod: record.time_period,
            locationType: location.location_type,
            userId: record.user_id
          });
        }
      });
    }
  });
  return hunters;
}

export function matchOfficerToMember(officer, members = []) {
  if (!officer?.name || !Array.isArray(members)) return null;
  const target = officer.name.trim().toLowerCase();
  if (!target) return null;
  return members.find((m) => {
    const profName = [m?.profile?.first_name, m?.profile?.last_name].filter(Boolean).join(' ').trim().toLowerCase();
    const memberName = [m?.first_name, m?.last_name].filter(Boolean).join(' ').trim().toLowerCase();
    const username = (m?.username || '').toLowerCase();
    return (profName && profName === target)
      || (memberName && memberName === target)
      || username === target;
  }) || null;
}

export function profileCardFromMember(member) {
  const profile = member?.profile && typeof member.profile === 'object' ? member.profile : {};
  return {
    photo_url: profile.photo_url || member?.photo_url || '',
    first_name: profile.first_name || member?.first_name || '',
    last_name: profile.last_name || member?.last_name || '',
    preferred_hunting_method: profile.preferred_hunting_method || member?.preferred_hunting_method || '',
    status: profile.status || member?.status || '',
  };
}

/** Avatars already on GET /clubs/:id/ members — no extra /users/:id/profile/ needed. */
export function profilesFromClub(club) {
  const out = {};
  (club?.members || []).forEach((member) => {
    if (member?.id == null) return;
    out[member.id] = profileCardFromMember(member);
  });
  return out;
}

export function collectProfileIds(club) {
  const ids = [];
  const seen = new Set();
  (club?.members || []).forEach((member) => {
    const id = member?.id;
    if (id != null) {
      const key = String(id);
      if (!seen.has(key)) {
        seen.add(key);
        ids.push(id);
      }
    }
  });
  (club?.officers || []).forEach((officer) => {
    const id = officer?.user_id;
    if (id != null) {
      const key = String(id);
      if (!seen.has(key)) {
        seen.add(key);
        ids.push(id);
      }
    }
  });
  return ids;
}

const clubUtils = {
  getHuntersInWoods,
  matchOfficerToMember,
  collectProfileIds,
  profileCardFromMember,
  profilesFromClub,
};

export default clubUtils;



